import { render, staticRenderFns } from "./MatchCardRow.vue?vue&type=template&id=68c034f2&scoped=true&"
import script from "./MatchCardRow.vue?vue&type=script&lang=ts&"
export * from "./MatchCardRow.vue?vue&type=script&lang=ts&"
import style0 from "./MatchCardRow.vue?vue&type=style&index=0&id=68c034f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c034f2",
  null
  
)

export default component.exports